import { jsx as _jsx } from "react/jsx-runtime";
import { Backdrop, Box } from '@mui/material';
import loadergif from './main-loader.gif';
import { useAppSelector } from '../../../../application/store/useStore';
const MainLoader = () => {
    const isLoading = useAppSelector((state) => state.loading.pendingRequestCount > 0);
    return (_jsx(Backdrop, { open: isLoading, sx: {
            color: '#fff',
            zIndex: (theme) => theme.zIndex.modal + 1,
            backdropFilter: 'blur(10px)',
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
        }, children: _jsx(Box, { sx: {
                width: {
                    xs: '150px',
                    sm: '150px',
                }
            }, component: 'img', src: loadergif, alt: 'Loading...' }) }));
};
export default MainLoader;
